import { Placement } from "@popperjs/core";
import { RiEdit2Line } from "@remixicon/react";
import classNames from "classnames";
import React, { ReactNode, useEffect, useState } from "react";
import { Popover as BootstrapPopover, OverlayTrigger } from "react-bootstrap";
import Button from "../../../theme/button/Button";

import { useChangingHandler } from "../../../../use-changing-callback";
import Styles from "./EditableLabel.module.scss";
import ArtificialIntelligenceButton from "../../../artificial-intelligence/AIButton";

export default function EditableLabel({
    children, menu, className, popoverClassName, placement, title, hideStyle,
    onHide, placeholder, buttonTitle, buttonClassName, icon, onAiClick, aIPreview, aiBody,
}: {
    menu: (onDone: (() => void)) => ReactNode;
    children: ReactNode;
    className?: string;
    popoverClassName?: string;
    placement?: Placement;
    placeholder?: ReactNode;
    title?: ReactNode;
    buttonTitle?: string;
    hideStyle?: "display" | "visibility" | "none"
    buttonClassName?: string;
    onHide?: () => void;
    icon?: ReactNode;
    onAiClick?: () => void;
    aIPreview?: string;
    aiBody?: ReactNode;
}) {
    const [isShow, setShow] = useState(false);

    const handleHide = useChangingHandler(() => {
        setShow(false);
        onHide?.();
    });

    const popover = (
        <BootstrapPopover
            className={classNames(
                Styles.popover,
                popoverClassName,
            )}
        >
            {title && (
                <BootstrapPopover.Header>{title}</BootstrapPopover.Header>
            )}
            <BootstrapPopover.Body>
                {menu(handleHide)}
            </BootstrapPopover.Body>
        </BootstrapPopover>
    );

    useEffect(() => () => {
        if (isShow) {
            handleHide();
        }
    }, [isShow]);

    return (
        <span className={classNames(Styles["editable-label"])}>
            {onAiClick && (
                <ArtificialIntelligenceButton
                    onClick={onAiClick}
                    popoverBody={aiBody}
                    previewText={aIPreview}
                    className={Styles["ai-button"]}
                />

            )}
            <span className={classNames(Styles.editable, Styles[`hide-style-${hideStyle}`], className)}>

                <OverlayTrigger
                    trigger="click"
                    placement={placement}
                    overlay={popover}
                    rootClose
                    show={isShow}
                    onToggle={nextValue => {
                        setShow(nextValue);
                        if (!nextValue) {
                            onHide?.();
                        }
                    }}
                >

                    <Button
                        type="button"
                        className={classNames(Styles["edit-button"], buttonClassName)}
                        variant="none"
                        size="large"
                        title={buttonTitle}
                        postfixIcon={icon
                            ? <span className={Styles["icon-edit"]}>{icon}</span>
                            : <RiEdit2Line className={Styles["icon-edit"]} />}
                    >
                        {children || <span className="label-placeholder">{placeholder}</span>}
                    </Button>

                </OverlayTrigger>
            </span>
        </span>

    );
}

EditableLabel.defaultProps = {
    className: "",
    popoverClassName: "",
    placement: "left",
    title: undefined,
    hideStyle: "display",
    onHide: undefined,
    placeholder: undefined,
    buttonTitle: undefined,
    buttonClassName: "",
    icon: undefined,
    onAiClick: undefined,
    aIPreview: undefined,
    aiBody: undefined,
};
